/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import {
  CloseContainer,
  ButtonContainer,
  SubmitButton,
  Link,
  Links,
  IconContainer,
  CloseIcon,
  ArrowIcon,
  Tab,
  Tabs,
  TabLabel,
  LoaderContainer,
  Category,
  CategoryList,
  FilterLabel,
  Filter,
  FilterSearch,
  FilterWrapper,
  FiltersContainer,
  FilterSearchContainer,
  SearchIcon,
  FilterRow,
} from "./NewSidebarModal.styles.js";

import Modal from "./Modal2.js";
import openToast from "../../utils/toast.js";
import Icon from "../Icon.js";

import { logout } from "../../store/slices/businessUser/asyncThunks.js";
import { logoutRecipient } from "../../store/slices/authRecipient/asyncThunks.js";

import { ReactComponent as AccountSettings } from "../../assets/icons/settings.svg";
import { ReactComponent as AccountSettingsUnSelected } from "../../assets/icons/settingsUnSelected.svg";
import { ReactComponent as Wallet } from "../../assets/icons/wallet.svg";
import { ReactComponent as WalletUnSelected } from "../../assets/icons/walletUnSelected.svg";
import { ReactComponent as OrderHistory } from "../../assets/icons/clock.svg";
import { ReactComponent as OrderHistoryUnSelected } from "../../assets/icons/clockUnSelected.svg";
import { ReactComponent as Favorite } from "../../assets/icons/heart.svg";
import { ReactComponent as FavoriteUnSelected } from "../../assets/icons/heartUnSelected.svg";
import { ReactComponent as Dashboard } from "../../assets/icons/dashboard.svg";
import { ReactComponent as DashboardUnSelected } from "../../assets/icons/dashboardUnSelected.svg";
import { ReactComponent as Marketplace } from "../../assets/icons/market.svg";
import { ReactComponent as MarketplaceUnSelected } from "../../assets/icons/marketUnSelected.svg";
import { ReactComponent as Coupon } from "../../assets/icons/coupon.svg";
import { ReactComponent as CouponUnSelected } from "../../assets/icons/couponUnSelected.svg";
import { ReactComponent as Subscription } from "../../assets/icons/sub.svg";
import { ReactComponent as SubscriptionUnSelected } from "../../assets/icons/subUnSelected.svg";
import { ReactComponent as Recipients } from "../../assets/icons/usergroup.svg";
import { ReactComponent as RecipientsUnSelected } from "../../assets/icons/usergroupUnSelected.svg";
import { countClickAction } from "../../store/slices/common/asyncThunks.js";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SearchInput from "../Search/Search.js";
import MiniLoader from "../MiniLoader/MiniLoader.js";
import { categoriesData } from "../../store/slices/gift/slice.js";
import { checkPermission, priceFormatter } from "../../utils/utils.js";
import Checkbox from "../Checkbox/Checkbox.js";
import { selectBusinessUserInfo } from "../../store/slices/businessUser/slice.js";
import { businessUserRoleAction } from "../../utils/constants.js";

const NewSidebarModal = ({
  open,
  close,
  role,
  t,
  ar,
  businessId,
  recipientId,
  loggedIn,
  pathname,
  sendGift,
  navigate,
}) => {
  const dispatch = useDispatch();
  const isSuperAdmin = role === "superAdmin";
  const toastId = useRef(null);
  const [tab, setTab] = useState("menu");
  const categories = useSelector(categoriesData);
  const [searchTerm, setSearchTerm] = useState("");
  const { categoryId } = useParams();
  const businessUser = useSelector(selectBusinessUserInfo);

  const handleCategoryClick = (categoryId) => {
    navigate(`/admin-portal/category-items/${categoryId}`);
  };

  useEffect(() => {
    if (sendGift) {
      setTab("categories");
    }

    if (
      pathname === "/marketplace" ||
      pathname === "/admin-portal/marketplace"
    ) {
      setTab("filters");
    }
  }, [sendGift, pathname]);

  const handleLogout = () => {
    if (businessId > 0) {
      dispatch(logout())
        .unwrap()
        .then(() => {
          close();
        })
        .catch((error) => {
          openToast(toastId, "logout-sidebar-modal", "error", t(error.message));
        });
    } else if (recipientId > 0) {
      dispatch(logoutRecipient())
        .unwrap()
        .then(() => {
          close();
        })
        .catch((error) => {
          openToast(toastId, "logout-sidebar-modal", "error", t(error.message));
        });
    }
  };

  const navLinks = [
    {
      to: "/admin-portal/dashboard",
      icon: <Dashboard height={24} width={24} />,
      iconUnSelected: <DashboardUnSelected height={24} width={24} />,
      label: "dashboard",
    },
    {
      to: "/admin-portal/marketplace",
      icon: <Marketplace height={24} width={24} />,
      iconUnSelected: <MarketplaceUnSelected height={24} width={24} />,
      label: "marketplace",
    },
    {
      to: "/admin-portal/recipients?page=1",
      icon: <Recipients height={24} width={24} />,
      iconUnSelected: <RecipientsUnSelected height={24} width={24} />,
      label: "recipients2",
    },
    {
      to: "/admin-portal/order-history?marketplacePage=1&giftsPage=1",
      icon: <OrderHistory height={24} width={24} />,
      iconUnSelected: <OrderHistoryUnSelected height={24} width={24} />,
      label: "my-orders",
    },
    {
      to: checkPermission(
        businessUser,
        businessUserRoleAction.get_bank_transfers,
      )
        ? "/admin-portal/billing?billingsPage=1&bankTransfersPage=1"
        : "/admin-portal/billing?billingsPage=1",
      icon: <Wallet height={24} width={24} />,
      iconUnSelected: <WalletUnSelected height={24} width={24} />,
      label: "wallet",
    },
    {
      to: "/admin-portal/favorite",
      icon: <Favorite height={24} width={24} />,
      iconUnSelected: <FavoriteUnSelected height={24} width={24} />,
      label: "favorites",
    },
    {
      to: checkPermission(
        businessUser,
        businessUserRoleAction.get_subscriptions,
      )
        ? "/admin-portal/subscriptions"
        : "/admin-portal/business-subscriptions?page=1",
      icon: <Subscription height={24} width={24} />,
      iconUnSelected: <SubscriptionUnSelected height={24} width={24} />,
      label: "subscriptions",
    },

    ...(checkPermission(businessUser, businessUserRoleAction.get_coupons)
      ? [
          {
            to: "/admin-portal/coupons",
            icon: <Coupon height={24} width={24} />,
            iconUnSelected: <CouponUnSelected height={24} width={24} />,
            label: "coupons",
          },
        ]
      : []),
  ];

  const [searchPrice, setSearchPrice] = useState("");
  const location = useLocation();
  const navigation = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const category = queryParams.get("category");
  const priceFromParam = queryParams.get("priceFrom");
  const priceToParam = queryParams.get("priceTo");

  const priceFilters = [
    { id: 1, priceFrom: 0, priceTo: 100 },
    { id: 2, priceFrom: 101, priceTo: 300 },
    { id: 3, priceFrom: 301, priceTo: 500 },
    { id: 4, priceFrom: 500 },
  ];

  const handleChecked = (filter) => {
    let checked = false;
    if (
      filter.priceFrom === parseInt(priceFromParam) &&
      filter.priceTo === parseInt(priceToParam)
    ) {
      checked = true;
    } else if (
      (!filter.priceFrom && filter.priceTo === parseInt(priceToParam)) ||
      (filter.priceFrom === parseInt(priceFromParam) && !filter.priceTo)
    ) {
      checked = true;
    }
    return checked;
  };

  return (
    <Modal
      onClose={close}
      open={open}
      left
      width={"567px"}
      height={"100%"}
      padding={"5rem 6rem"}
      unset
      responsive
    >
      {sendGift && (
        <Tabs>
          <Tab onClick={() => setTab("categories")} $loggedIn={loggedIn}>
            <TabLabel $active={tab === "categories"}>
              {t("categories.categories")}
            </TabLabel>
          </Tab>
          <Tab onClick={() => setTab("menu")} $loggedIn={loggedIn}>
            <TabLabel $active={tab === "menu"}>{t("menu")}</TabLabel>
          </Tab>
        </Tabs>
      )}
      {(pathname === "/marketplace" ||
        pathname === "/admin-portal/marketplace") && (
        <Tabs>
          <Tab onClick={() => setTab("filters")} $loggedIn={loggedIn}>
            <TabLabel $active={tab === "filters"}>{t("filters")}</TabLabel>
          </Tab>
          {loggedIn && (
            <Tab onClick={() => setTab("menu")} $loggedIn={loggedIn}>
              <TabLabel $active={tab === "menu"}>{t("menu")}</TabLabel>
            </Tab>
          )}
        </Tabs>
      )}

      {tab === "menu" && (
        <>
          <Links>
            <CloseContainer
              onClick={() => {
                close();
                setSearchTerm("");
              }}
            >
              <CloseIcon />
            </CloseContainer>
            {navLinks.map(({ to, icon, iconUnSelected, label }) => (
              <Link
                key={to}
                to={to}
                onClick={() => {
                  close();
                  window.scrollTo(0, 0);
                  if (label === "marketplace") {
                    dispatch(countClickAction("marketplace"));
                  }
                }}
                children={({ isActive }) => {
                  return (
                    <>
                      <IconContainer>
                        {isActive ? (
                          <Icon icon={icon} selectedLocale={ar} />
                        ) : (
                          <Icon icon={iconUnSelected} selectedLocale={ar} />
                        )}
                      </IconContainer>
                      {t(`${label}`)}
                    </>
                  );
                }}
              />
            ))}

            <Link
              onClick={() => {
                close();
                window.scrollTo(0, 0);
              }}
              to={"/admin-portal/account-settings"}
              children={({ isActive }) => {
                return (
                  <>
                    <IconContainer>
                      {isActive ? (
                        <Icon
                          icon={<AccountSettings height={24} width={24} />}
                          selectedLocale={ar}
                        />
                      ) : (
                        <Icon
                          icon={
                            <AccountSettingsUnSelected height={24} width={24} />
                          }
                          selectedLocale={ar}
                        />
                      )}
                    </IconContainer>
                    {t("account-settings")}
                  </>
                );
              }}
            />
            {isSuperAdmin && (
              <Link
                onClick={() => {
                  close();
                  window.scrollTo(0, 0);
                }}
                to={"/ops-portal"}
                children={({}) => {
                  return (
                    <>
                      {t("ops-portal")}

                      <IconContainer>
                        <ArrowIcon $ar={ar} />
                      </IconContainer>
                    </>
                  );
                }}
              />
            )}
            {!pathname.includes("pricing") && loggedIn && (
              <Link
                onClick={() => {
                  window.scrollTo(0, 0);
                  dispatch(countClickAction("giftingAsAService"));
                  close();
                }}
                to={"/pricing"}
                children={({}) => {
                  return (
                    <>
                      {t("gaas")}

                      <IconContainer>
                        <ArrowIcon $ar={ar} />
                      </IconContainer>
                    </>
                  );
                }}
              />
            )}
            <Link
              onClick={() => {
                window.scrollTo(0, 0);
                close();
              }}
              to={"/sign-up/steps/upgrade"}
              children={({}) => {
                return (
                  <>
                    {t("upgrade-your-account")}

                    <IconContainer>
                      <ArrowIcon $ar={ar} />
                    </IconContainer>
                  </>
                );
              }}
            />
          </Links>
        </>
      )}

      {tab === "filters" && (
        <>
          <CloseContainer
            onClick={() => {
              close();
              setSearchPrice("");
              setSearchTerm("");
            }}
          >
            <CloseIcon />
          </CloseContainer>
          <FiltersContainer>
            <FilterWrapper>
              <FilterSearchContainer>
                <FilterSearch
                  $ar={ar}
                  placeholder={t("price")}
                  value={searchPrice}
                  onChange={(e) => {
                    setSearchPrice(e.target.value);
                    if (e.target.value) {
                      let path = location.pathname;
                      let query = "?";
                      if (category && category !== null) {
                        path += `?category=${category}`;
                        query = "&";
                      }

                      path += query + `priceTo=${e.target.value}`;

                      navigation(path);
                    } else {
                      let path = location.pathname;
                      if (category && category !== null) {
                        path += `?category=${category}`;
                      }

                      navigation(path);
                    }
                  }}
                />
                <SearchIcon $active={searchPrice !== ""} $ar={ar} />
              </FilterSearchContainer>
              {priceFilters.map((filter, i) => {
                return (
                  <Filter
                    key={i}
                    onClick={() => {
                      if (
                        filter.priceFrom === parseInt(priceFromParam) &&
                        filter.priceTo === parseInt(priceToParam)
                      ) {
                        let path = location.pathname;
                        if (category && category !== null) {
                          path += `?category=${category}`;
                        }
                        navigation(path);
                      } else {
                        setSearchPrice("");

                        let path = location.pathname;
                        let query = "?";
                        if (category && category !== null) {
                          path += `?category=${category}`;
                          query = "&";
                        }

                        if (filter.priceFrom || filter.priceFrom === 0) {
                          path += query + `priceFrom=${filter.priceFrom}`;
                          query = "&";
                        }
                        if (filter.priceTo) {
                          path += query + `priceTo=${filter.priceTo}`;
                        }
                        navigation(path);
                      }
                    }}
                  >
                    <Checkbox checked={handleChecked(filter)} size={24} />
                    {filter.priceTo ? (
                      filter.priceFrom === 0 ? (
                        <FilterLabel>
                          {`Under ${priceFormatter(
                            filter.priceTo,
                            false,
                            0,
                          )} SR`}
                        </FilterLabel>
                      ) : (
                        <FilterRow>
                          <FilterLabel>
                            {priceFormatter(filter.priceFrom, false, 0)}
                          </FilterLabel>
                          <FilterLabel>SR</FilterLabel>
                          <FilterLabel>-</FilterLabel>
                          <FilterLabel>
                            {priceFormatter(filter.priceTo, false, 0)}
                          </FilterLabel>
                          <FilterLabel>SR</FilterLabel>
                        </FilterRow>
                      )
                    ) : (
                      <FilterLabel>
                        {`Above ${priceFormatter(
                          filter.priceFrom,
                          false,
                          0,
                        )} SR`}
                      </FilterLabel>
                    )}
                  </Filter>
                );
              })}
            </FilterWrapper>
          </FiltersContainer>
        </>
      )}

      {tab === "categories" &&
        (categories.length > 0 ? (
          <>
            <CloseContainer
              onClick={() => {
                close();
                setSearchTerm("");
                setSearchPrice("");
              }}
            >
              <CloseIcon />
            </CloseContainer>
            <SearchInput
              searchStyle2
              placeholder={t("search-categories")}
              type="text"
              styles2={{
                marginBottom: "1rem",
                borderRadius: 10,
                background: "#f6f6f9",
                boxShadow: "0px 0px 5px rgba(0,0,0,0.15)",
              }}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <CategoryList className="vertical-scroll">
              {categories
                .filter((category) =>
                  category.name
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase()),
                )
                .map((category) => (
                  <Category
                    $active={category.id === +categoryId}
                    key={category.id}
                    onClick={() => {
                      close();
                      setSearchTerm("");
                      window.scrollTo(0, 0);
                      handleCategoryClick(category.id);
                    }}
                  >
                    {t(
                      "categories." +
                        [
                          category.name
                            .toLowerCase()
                            .replace(" ", "-")
                            .replace("/", "-"),
                        ],
                    )}
                  </Category>
                ))}
            </CategoryList>
          </>
        ) : (
          <LoaderContainer>
            <MiniLoader small />
          </LoaderContainer>
        ))}

      {loggedIn && (
        <ButtonContainer>
          <SubmitButton onClick={handleLogout}>{t("logout")}</SubmitButton>
        </ButtonContainer>
      )}
    </Modal>
  );
};

export default NewSidebarModal;
